export const ensureWindowCache = () => {
    if (typeof window === 'undefined') {
      return { cache: {}, promises: {} };
    }
  
    if (!window.__emotionDataCache) {
      window.__emotionDataCache = {};
    }
  
    if (!window.__emotionDataPromises) {
      window.__emotionDataPromises = {};
    }
  
    return {
      cache: window.__emotionDataCache,
      promises: window.__emotionDataPromises
    };
  };
  
  export const buildProcessedData = (sessions) => {
    const emotionCounts = {
      positive: 0,
      neutral: 0,
      negative: 0
    };
  
    sessions.forEach((session) => {
      const emotion = (session.Emotion || session.emotion || '').toLowerCase();
      if (emotionCounts.hasOwnProperty(emotion)) {
        emotionCounts[emotion] += 1;
      }
    });
  
    const barChartData = Object.entries(emotionCounts).map(([emotion, count]) => ({
      emotion,
      count
    }));
  
    return {
      rawData: sessions,
      processedData: {
        barChart: barChartData,
        pieChart: barChartData,
        radialChart: []
      },
      loading: false,
      error: null
    };
  };